import {
  UPLOAD_IMAGE_CROP_CORNER,
  UPLOAD_IMAGE_CROP_SHAPE,
  UPLOAD_IMAGE_DEFAULT_RECTANGLE_ASPECT,
} from './UploadImage.constants'

export function isUploadImageCropShapeCircle(cropShape) {
  return cropShape === UPLOAD_IMAGE_CROP_SHAPE.CIRCLE
}

export function isUploadImageCropCornerNW(corner) {
  return corner === UPLOAD_IMAGE_CROP_CORNER.NW
}

export function isUploadImageCropCornerNE(corner) {
  return corner === UPLOAD_IMAGE_CROP_CORNER.NE
}

export function isUploadImageCropCornerSW(corner) {
  return corner === UPLOAD_IMAGE_CROP_CORNER.SW
}

export function isUploadImageCropCornerSE(corner) {
  return corner === UPLOAD_IMAGE_CROP_CORNER.SE
}

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

// Keeps a crop of unchanged size inside the displayed image bounds.
export function clampCropPosition({ crop, layout }) {
  const maxX = layout.imageX + layout.displayWidth - crop.width
  const maxY = layout.imageY + layout.displayHeight - crop.height

  return {
    ...crop,
    x: clamp(crop.x, layout.imageX, maxX),
    y: clamp(crop.y, layout.imageY, maxY),
  }
}

// Circle/square crop to 1:1; rectangle keeps the logo ratio unless `aspect` is set.
export function resolveUploadImageAspect({ aspect, cropShape }) {
  if (aspect) {
    return aspect
  }

  if (cropShape === UPLOAD_IMAGE_CROP_SHAPE.RECTANGLE) {
    return UPLOAD_IMAGE_DEFAULT_RECTANGLE_ASPECT
  }

  return 1
}

export function isAcceptedImageFile(file) {
  return Boolean(file) && file.type.startsWith('image/')
}
